class Debugger {
  initial = async () => {
    return {
      web: false,
      magic: false,
      instrumentation: false,
    };
  };

  initialPath = async () => {
    return {
      web: null,
      magic: null,
    };
  };

  get = async () => {
    let debug = await this.initial();

    const storedData = localStorage.getItem('debugger');

    if (storedData) {
      debug = JSON.parse(storedData);
    }

    return debug;
  };

  set = async debug => {
    localStorage.setItem('debugger', JSON.stringify(debug));
  };

  getStatus = async () => {
    const storedData = localStorage.getItem('debugger-status');

    if (storedData) {
      return storedData;
    }

    return false;
  };

  setStatus = async status => {
    localStorage.setItem('debugger-status', JSON.stringify(status));
  };

  getPath = async () => {
    let path = await this.initialPath();

    const storedData = localStorage.getItem('debugger-path');

    if (storedData) {
      path = JSON.parse(storedData);
    }

    return path;
  };

  setPath = async path => {
    localStorage.setItem('debugger-path', JSON.stringify(path));
  };
}

export default new Debugger();
